import 'intersection-observer';
import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import {ja, en} from 'vuetify/src/locale';

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: {ja, en},
    current: 'ja',
  },
  icons: {
    iconfont: 'mdi',
  },
});
